import * as ActionTypes from '../../actions/allActions'

const bookingInit = { fetched: false }
const booking = (state = bookingInit, action) => {
	switch(action.type){
		case ActionTypes.FETCHBOOKING_REQUEST:
			return { ...state, fetched: false }
		case ActionTypes.FETCHBOOKING_SUCCESS:
			return { ...state, fetched: true }
		case ActionTypes.LOGOUT:
			return bookingInit
		default:
			return state
	}
}

export default booking



// WEBPACK FOOTER //
// ./src/reducers/metadata/booking.js